import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Filter } from 'lucide-react';
import { mockData } from '../data/mock';

const Portfolio = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  
  const categories = ['All', 'Brand Identity', 'Web Design', 'UI/UX Design', 'Print Design'];
  
  const filteredProjects = selectedCategory === 'All' 
    ? mockData.portfolio 
    : mockData.portfolio.filter(project => project.category === selectedCategory);

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="section-padding bg-gradient-to-br from-primary to-primary-dark pt-28" style={{ paddingTop: '6.5rem' }}>
        <div className="container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="hero-text mb-6">Our Portfolio</h1>
            <p className="text-xl text-gray-800 leading-relaxed">
              Explore our featured projects and see how we've helped brands transform their digital presence and achieve remarkable results.
            </p>
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="section-padding bg-white">
        <div className="container">
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            <div className="flex items-center gap-2 text-gray-600 mr-4">
              <Filter size={20} />
              <span className="font-medium">Filter by:</span>
            </div>
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-2 rounded-full font-medium transition-all ${
                  selectedCategory === category
                    ? 'bg-black text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Portfolio Grid */}
      <section className="pb-16" style={{padding:'4rem'}}>
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProjects.map((project, index) => (
              <Link 
              to={`/${project.id}`}
              key={project.id}
              className="card-white group cursor-pointer overflow-hidden block">
              <div className="aspect-square bg-black rounded-lg mb-6 overflow-hidden">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="bg-black w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-gray-600 bg-gray-100 px-3 py-1 rounded-full">
                    {project.category}
                  </span>
                  <span className="text-sm text-gray-500">{project.year}</span>
                </div>

                <h3 className="font-semibold text-xl group-hover:text-gray-700 transition-colors">
                  {project.title}
                </h3>
              </div>
            </Link>
            ))}
          </div>
          
          {filteredProjects.length === 0 && (
            <div className="text-center py-16">
              <p className="text-gray-500 text-lg">No projects found in this category.</p>
            </div>
          )}
        </div>
      </section>

          {/* <p className="text-gray-600 leading-relaxed">
            {project.description}
          </p>
          <div className="pt-4">
            <div className="text-sm text-gray-500">Client: <span className="font-medium">{project.client}</span></div>
          </div> */}


      {/* Case Study Preview */}
      {/* <section className="section-padding bg-gray-50">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="section-header mb-4">Featured Case Study</h2>
              <p className="text-xl text-gray-700">
                Dive deep into one of our most successful projects and see the complete transformation process
              </p>
            </div>
            
            <div className="card-white">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                <div>
                  <img 
                    src="https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=600&h=400&fit=crop" 
                    alt="TechStart Brand Identity"
                    className="w-full rounded-lg shadow-md"
                  />
                </div>
                <div className="space-y-6">
                  <div>
                    <span className="text-sm font-medium text-gray-600 bg-gray-100 px-3 py-1 rounded-full">
                      Brand Identity
                    </span>
                    <h3 className="subsection-header mt-4 mb-3">TechStart Complete Rebrand</h3>
                    <p className="text-gray-700 leading-relaxed">
                      A comprehensive brand transformation that increased brand recognition by 250% and helped secure $2M in Series A funding.
                    </p>
                  </div>
                  
                  <div className="space-y-4">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <div className="text-2xl font-bold text-black">250%</div>
                        <div className="text-sm text-gray-600">Brand Recognition Increase</div>
                      </div>
                      <div>
                        <div className="text-2xl font-bold text-black">$2M</div>
                        <div className="text-sm text-gray-600">Series A Funding Raised</div>
                      </div>
                    </div>
                    
                    <div>
                      <h4 className="font-semibold mb-2">Project Scope:</h4>
                      <ul className="text-sm text-gray-600 space-y-1">
                        <li>• Complete brand identity redesign</li>
                        <li>• Website development and optimization</li>
                        <li>• Marketing collateral design</li>
                        <li>• Social media brand guidelines</li>
                      </ul>
                    </div>
                  </div>
                  
                  <Link to="/contact" className="btn-primary">
                    Discuss Your Project <ArrowRight size={20} />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Client Testimonials */}
      <section className="section-padding bg-white">
        <div className="container ">
          <div className="text-center mb-16">
            <h2 className="section-header mb-4">What Our Clients Say</h2>
            <p className="text-xl text-gray-700 max-w-2xl mx-auto">
              Real feedback from real clients who've experienced the NS7VISUALS difference
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {mockData.testimonials.slice(0, 4).map((testimonial, index) => (
              <div key={index} className="card group hover:shadow-xl transition-all duration-300">
                <div className="flex items-center mb-6">
                  <img 
                    src={testimonial.avatar} 
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full mr-4 object-cover bg-black"
                  />
                  <div>
                    <div className="font-semibold text-lg">{testimonial.name}</div>
                    <div className="text-gray-300">{testimonial.position}</div>
                    <div className="text-sm text-gray-500">{testimonial.company}</div>
                  </div>
                </div>
                <p className="text-gray-100 italic leading-relaxed">
                  "{testimonial.quote}"
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
            <section className="section-padding bg-black text-white">
              <div className="container text-center">
                <h2 className="section-headers mb-4 text-white">Ready to Get Started?</h2>
                <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
                  Let's discuss your project and explore how we can help bring your vision to life
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Link to="/contact" className="bg-white text-black px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors">
                    Start Your Project
                  </Link>
                  <Link to="/portfolio" className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-black transition-colors">
                    View Our Work
                  </Link>
                </div>
              </div>
            </section>
    </div>
  );
};

export default Portfolio;